<template>
	<div class="shift-row" :style="limitColors">
		<p>{{ position }}</p>
		<span>{{ current }}/{{ total }}</span>
	</div>
</template>

<script>
export default {
	name: 'dayInfoShiftRow',
	props: {
		position: { required: false },
		current: { required: false },
		total: { required: false },
	},
	computed: {
		limitColors() {
			return {
				'--limitColor': this.current === this.total ? '#7cc230' : '#f58323',
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.shift-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 10px;
	p {
		font-size: 12px;
		margin-bottom: 0;
	}
	span {
		font-size: 16px;
		font-weight: bold;
		color: var(--limitColor);
	}
}
</style>
